<script setup lang="ts">
import { Head } from '@inertiajs/vue3';
import CtaBannerSection from '@/components/landing/CtaBannerSection.vue';
import FaqSection from '@/components/landing/FaqSection.vue';
import FeaturesSection from '@/components/landing/FeaturesSection.vue';
import FooterSection from '@/components/landing/FooterSection.vue';
import HeroSection from '@/components/landing/HeroSection.vue';
import MetricsSection from '@/components/landing/MetricsSection.vue';
import PricingSection from '@/components/landing/PricingSection.vue';
import ProblemSection from '@/components/landing/ProblemSection.vue';
import SocialProofSection from '@/components/landing/SocialProofSection.vue';
import AppHeaderLayoutLanding from '@/layouts/app/AppHeaderLayoutLanding.vue';

withDefaults(
    defineProps<{
        canRegister: boolean;
    }>(),
    {
        canRegister: true,
    },
);
</script>

<template>
    <Head title="Welcome" />

    <AppHeaderLayoutLanding :canRegister="canRegister">
        <HeroSection />
        <ProblemSection />
        <FeaturesSection />
        <SocialProofSection />
        <MetricsSection />
        <PricingSection />
        <FaqSection />
        <CtaBannerSection />
        <FooterSection />
    </AppHeaderLayoutLanding>
</template>
